import { formatCurrency } from '@angular/common';

import {DetailScreen} from '../mapping-classes/detail-screen';
import {DetailPanel} from '../mapping-classes/detail-panel';
import {DetailLabel} from '../mapping-classes/detail-label';
import {ButtonData} from "../mapping-classes/button-data";

export class Sparendeposito implements DetailScreen {
  buttons;
  restrictedData: boolean;
  title: string;
  actualityDateTime: string;
  panels: DetailPanel[];
  nameValues: DetailLabel[];
  shieldedText = 'Afgeschermd';
  errorText: string;

  constructor(response: any) {
    this.title = 'Sparen (Productnaam Deposito)';
    this.buttons = [];
    this.restrictedData = false;
    if (response.detailsViewObject) {
      this.title = response.detailsViewObject.productName || this.title;
    }

    if (response.listOfError && response.listOfError.length) {
      this.createErrorMessage(response);
    } else {
      this.panels = [];
      this.nameValues = [];
      this.setPanels();
      this.setNameAndValues(response);
      this.addValues(response);
      this.addButtons(response.detailsViewObject);
    }
  }

  addButtons(res) {
    const data =  {
      arrangementNumber: res.iban.substring(8),
      administrationCode: res.adminCode,
    };
    this.buttons.push(new ButtonData(
      'cockpiturl',
      null,
      null,
      null,
      'B&O Cockpit',
      null,
      'boc-url', data));
    this.buttons.push(new ButtonData(
      'geldOverPortaalurl',
      null,
      null,
      null,
      'Medewerkers App Geld Over',
      null,
      'geldOver-url', res.relationId));
  }

  setPanels() {
    this.panels.push(new DetailPanel('Productkenmerken'));
    this.panels.push(new DetailPanel('Productafspraken'));
    this.panels.push(new DetailPanel('Productgebruik'));
    const productAfsprakenPanel: DetailPanel = this.panels[1];
    productAfsprakenPanel.subPanels.push(new DetailPanel('Inleg'));
    productAfsprakenPanel.subPanels.push(new DetailPanel('Rente'));
    productAfsprakenPanel.subPanels.push(new DetailPanel('Terugbetaling'));
  }

  setNameAndValues(response?) {
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreements:  DetailPanel = this.panels[1];
    const productUse:  DetailPanel = this.panels[2];

    this.fillProductDetailsPanel(productDetailsPanel);
    this.fillProductAgreementsPanel(productAgreements);
    this.fillProductUsePanel(productUse);
  }

  addValues(response: any) {
    const obj = response.detailsViewObject;
    const productDetailsPanel: DetailPanel = this.panels[0];
    const productAgreementsPanel: DetailPanel = this.panels[1];
    const productUsePanel: DetailPanel = this.panels[2];
    this.addValuesToProductDetailsPanel(productDetailsPanel, obj);
    this.addValuesToProductAgreementsPanel(productAgreementsPanel, obj);
    this.addValuesToProductUsePanel(productUsePanel, obj);
  }

  createErrorMessage(response) {
    if (response.listOfError && response.listOfError.length !== 0) {
      if (response.listOfError[0].code === 'CIV_F025') {
        this.errorText = 'Geen detail gegevens gevonden.';
      } else if (response.listOfError[0].code) {
        this.errorText = 'Product niet gevonden.';
      }
    }
  }

  private fillProductDetailsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('iban', new DetailLabel('Rekeningnummer'));
    productDetailsPanel.nameAndValues.set('accountStatus', new DetailLabel('Status'));
    productDetailsPanel.nameAndValues.set('ascriptionId', new DetailLabel('Tenaamstelling'));
    productDetailsPanel.nameAndValues.set('code', new DetailLabel('ABB Code (Overig)'));
    productDetailsPanel.nameAndValues.set('description', new DetailLabel('Omschrijving'));
  }

  private addValuesToProductDetailsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('iban').setValue(obj.iban || '-');
    productDetailsPanel.nameAndValues.get('accountStatus').setValue(obj.accountStatus || '-');
    productDetailsPanel.nameAndValues.get('ascriptionId').setValue(obj.tenaamstelling || '-');
    productDetailsPanel.nameAndValues.get('code').setValue((obj.abbCode) ? obj.abbCode.code : '-');
    productDetailsPanel.nameAndValues.get('description').setValue((obj.abbCode) ? obj.abbCode.description : '-');
  }

  private fillProductAgreementsPanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('releaseAmountAccountIban', new DetailLabel('Vrijboekrekening'));
    productDetailsPanel.nameAndValues.set('interestAccountIban', new DetailLabel('Renterekening'));
    productDetailsPanel.nameAndValues.set('agreementAbbCodeCode', new DetailLabel('Overeenkomst ABB Code'));
    productDetailsPanel.nameAndValues.set('startDate', new DetailLabel('Ingangsdatum'));
    productDetailsPanel.nameAndValues.set('lastMutationDate', new DetailLabel('Laatste mutatie'));
    productDetailsPanel.nameAndValues.set('releaseAmountAccountAscriptionName', new DetailLabel('Tenaamstelling'));
    productDetailsPanel.nameAndValues.set('interestAccountAscriptionName', new DetailLabel('Tenaamstelling'));
    productDetailsPanel.nameAndValues.set('agreementAbbCodeDescription', new DetailLabel('Omschrijving'));

    const inlegSubPanel: DetailPanel = productDetailsPanel.subPanels[0];
    inlegSubPanel.nameAndValues.set('depositoSpecificDetailsDepositAmount', new DetailLabel('Bedrag'));
    inlegSubPanel.nameAndValues.set('depositoSpecificDetailsDepositoStartDate', new DetailLabel('Ingangsdatum'));
    inlegSubPanel.nameAndValues.set('depositoSpecificDetailsDepositPaymentMethod', new DetailLabel('Betaalwijze'));
    inlegSubPanel.nameAndValues.set('depositoSpecificDetailsDepositStatus', new DetailLabel('Deposito Status'));

    const renteSubPanel: DetailPanel = productDetailsPanel.subPanels[1];
    renteSubPanel.nameAndValues.set('depositoSpecificDetailsContractInterestRate', new DetailLabel('Rentepercentage'));
    renteSubPanel.nameAndValues.set('depositoSpecificDetailsContractAdviceInterestRate', new DetailLabel('Adviesrentepercentage'));
    renteSubPanel.nameAndValues.set('depositoSpecificDetailsPaymentFrequency', new DetailLabel('Betaalfrequentie'));
    renteSubPanel.nameAndValues.set('depositoSpecificDetailsInterestCalculationMethod', new DetailLabel('RenteBerekenmethode'));

    const terugbetalingSubPanel: DetailPanel = productDetailsPanel.subPanels[2];
    terugbetalingSubPanel.nameAndValues.set('depositoSpecificDetailsContractMaturityDate', new DetailLabel('Vervaldatum'));
    terugbetalingSubPanel.nameAndValues.set('depositoSpecificDetailsRenewalNumberOfMonths', new DetailLabel('Looptijd in maanden'));
    terugbetalingSubPanel.nameAndValues.set('depositoSpecificDetailsRepaymentMethod', new DetailLabel('Betaalwijze'));
    terugbetalingSubPanel.nameAndValues.set('depositoSpecificDetailsRenewalLastMaturityDate', new DetailLabel('Voortijdige beeindiging'));

  }

  private addValuesToProductAgreementsPanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('releaseAmountAccountIban').setValue((obj.releaseAmountAccount)
      ? obj.releaseAmountAccount.iban  : '-');
    productDetailsPanel.nameAndValues.get('interestAccountIban').setValue((obj.interestAccount)
      ? obj.interestAccount.iban : '-');
    productDetailsPanel.nameAndValues.get('agreementAbbCodeCode').setValue((obj.agreementAbbCode)
      ? obj.agreementAbbCode.code : '-');
    productDetailsPanel.nameAndValues.get('startDate').setValue(obj.startDate || '-');
    productDetailsPanel.nameAndValues.get('lastMutationDate').setValue(obj.lastMutationDate || '-');
    productDetailsPanel.nameAndValues.get('releaseAmountAccountAscriptionName').setValue((obj.releaseAmountAccount)
      ? obj.releaseAmountAccount.ascriptionName : '-');
    productDetailsPanel.nameAndValues.get('interestAccountAscriptionName').setValue((obj.interestAccount)
      ? obj.interestAccount.ascriptionName : '-');
    productDetailsPanel.nameAndValues.get('agreementAbbCodeDescription').setValue((obj.agreementAbbCode)
      ? obj.agreementAbbCode.description : '-');

    this.setSubPanels(productDetailsPanel, obj);
  }

  private setSubPanels(productDetailsPanel: DetailPanel, obj) {

    const inlegSubPanel: DetailPanel = productDetailsPanel.subPanels[0];
    inlegSubPanel.nameAndValues.get('depositoSpecificDetailsDepositAmount').setValue((obj.depositoSpecificDetails)
      ? formatCurrency(obj.depositoSpecificDetails.depositAmount, 'nl', '€') : '-');
    inlegSubPanel.nameAndValues.get('depositoSpecificDetailsDepositoStartDate').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.depositoStartDate : '-');
    inlegSubPanel.nameAndValues.get('depositoSpecificDetailsDepositPaymentMethod').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.depositPaymentMethod : '-');
    inlegSubPanel.nameAndValues.get('depositoSpecificDetailsDepositStatus').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.depositStatus : '-');

    const renteSubPanel: DetailPanel = productDetailsPanel.subPanels[1];
    renteSubPanel.nameAndValues.get('depositoSpecificDetailsContractInterestRate').setValue(obj.depositoSpecificDetails
      ? `${obj.depositoSpecificDetails.contractInterestRate} %` : '-');
    renteSubPanel.nameAndValues.get('depositoSpecificDetailsContractAdviceInterestRate').setValue((obj.depositoSpecificDetails)
      ? `${obj.depositoSpecificDetails.contractAdviceInterestRate} %` : '-');
    renteSubPanel.nameAndValues.get('depositoSpecificDetailsPaymentFrequency').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.paymentFrequency : '-');
    renteSubPanel.nameAndValues.get('depositoSpecificDetailsInterestCalculationMethod').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.interestCalculationMethod : '-');

    const terugbetalingSubPanel: DetailPanel = productDetailsPanel.subPanels[2];
    terugbetalingSubPanel.nameAndValues.get('depositoSpecificDetailsContractMaturityDate').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.contractMaturityDate : '-');
    terugbetalingSubPanel.nameAndValues.get('depositoSpecificDetailsRenewalNumberOfMonths').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.renewalNumberOfMonths : '-');
    terugbetalingSubPanel.nameAndValues.get('depositoSpecificDetailsRepaymentMethod').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.repaymentMethod : '-');
    terugbetalingSubPanel.nameAndValues.get('depositoSpecificDetailsRenewalLastMaturityDate').setValue((obj.depositoSpecificDetails)
      ? obj.depositoSpecificDetails.renewalLastMaturityDate : '-');
  }

  private fillProductUsePanel(productDetailsPanel: DetailPanel) {
    productDetailsPanel.nameAndValues.set('balance', new DetailLabel('Saldo'));
    productDetailsPanel.nameAndValues.set('accruedInterest', new DetailLabel('Opgebouwde rente'));
  }

  private addValuesToProductUsePanel(productDetailsPanel: DetailPanel, obj) {
    productDetailsPanel.nameAndValues.get('balance')
      .setValue(formatCurrency(obj.balance, 'nl', '€') || '-');
    productDetailsPanel.nameAndValues.get('accruedInterest')
      .setValue(formatCurrency(obj.accruedInterest, 'nl', '€') || '-');
  }
}
